import { useEffect, useState } from "react";
import styles from "../../../ProductsDetails.module.css";
import { useTranslation } from "react-i18next";
import AnimatedDetailsText from "../../../AnimatedDetailsText";
import ModelSlider from "../../../ModelSlider";

function VeneraDimmer() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // const [imagesLoaded, setImagesLoaded] = useState({});
  const { i18n } = useTranslation(); // إضافة i18n للحصول على اللغة الحالية

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);

  // const handleImageLoad = (index) => {
  //   setImagesLoaded((prevState) => ({
  //     ...prevState,
  //     [index]: true,
  //   }));
  // };
  const { t } = useTranslation();

  // const basePath = `${process.env.PUBLIC_URL}/images/02-tis-air/Panels/details/venera-dimmer`;
  // const smallScreenPath = `${basePath}/smallScreens`;

  const imageBasePath = isSmallScreen
  ? `${process.env.PUBLIC_URL}/images/02-tis-air/Panels/details/venera-dimmer/smallScreens`
  : `${process.env.PUBLIC_URL}/images/02-tis-air/Panels/details/venera-dimmer`;

const modelBasePath = `${process.env.PUBLIC_URL}/images/02-tis-air/Panels/details/venera-dimmer`;

const videoBasePath = `${process.env.PUBLIC_URL}/images/02-tis-air/Panels/details/venera-dimmer`;
  const mediaData = [
    {
      type: "image",
      src: isSmallScreen ? "01.jpg" : "01.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle1`),
      top: isSmallScreen ? "15%" : "15%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "60%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "02.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "25%" : "50%",
      left: isSmallScreen ? "52%" : "60%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "03.jpg" : "03.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle3`),
      top: isSmallScreen ? "25%" : "50%",
      left: isSmallScreen ? "50%" : "30%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "04.jpg" : "04.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle4`),
      
      top: isSmallScreen ? "15%" : "47%",
      left: isSmallScreen ? "50%" : "60%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "05.jpg" : "05.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle5`),
      
      top: isSmallScreen ? "25%" : "30%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "40%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "06.jpg" : "06.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle6`),
      
      top: isSmallScreen ? "20%" : "20%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "07.jpg" : "07.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle7`),
      
      top: isSmallScreen ? "20%" : "50%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "85%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "image",
      src: isSmallScreen ? "08.jpg" : "08.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle8`),
      
      top: isSmallScreen ? "20%" : "17%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "75%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "video",
      src: "09.mp4",
      title: "",
      subtitle: ``,
      top: isSmallScreen ? "84%" : "30%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "10.jpg" : "10.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle10`),
      
      top: isSmallScreen ? "20%" : "40%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "11.jpg" : "11.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle11`),
      
      top: isSmallScreen ? "25%" : "40%",
      left: isSmallScreen ? "50%" : "60%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "85%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "12.jpg" : "12.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle12`),
      
      top: isSmallScreen ? "20%" : "15%",
      left: isSmallScreen ? "65%" : "50%",
      textAlign: isSmallScreen ? "left" : "center",
      width: isSmallScreen ? "50%" : "40%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "13.jpg" : "13.jpg",
      
      title: t(`airVeneraDimmer.title13`),
      subtitle: t(`airVeneraDimmer.subtitle13`),
      
      top: isSmallScreen ? "20%" : "50%",
      left: isSmallScreen ? "50%" : "30%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      type: "image",
      src: isSmallScreen ? "14.jpg" : "14.jpg",
      title: "",
      subtitle: t(`airVeneraDimmer.subtitle14`),
      
      top: isSmallScreen ? "84%" : "68%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      type: "video",
      src: "15.mp4",
      title: "",
      subtitle: isSmallScreen ? "":t(`airVeneraDimmer.subtitle15`),
      
      top: isSmallScreen ? "45%" : "50%",
      left: isSmallScreen ? "75%" : "75%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "85%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: false,
      color: isSmallScreen ? "#000" : "#000",
    },
  ];



  const modelsData = [
    {
      id: 1,
      name: "VEN-1D-UV",
      image: `${modelBasePath}/models/01.png`,
    },
  ];

  const textDirection = i18n.language === "ar" ? "rtl" : "ltr"; // تعيين اتجاه الكتابة بناءً على اللغة
  return (
    <div className={styles.container} style={{ direction: textDirection }}>
      {mediaData.map((item, index) => (
        <div
          key={index}
          className={styles.imgContainer}
          style={{ position: "relative", width: "100%", display: "block" }}
        >
          {item.type === "image" ? (
            <img
              style={{ width: "100%" }}
              src={`${imageBasePath}/${item.src}`}
              alt=""
            />
          ) : (
            <div className={styles.videoContainer}>
              <video
                className={styles.fullscreenVideo}
                src={`${videoBasePath}/${item.src}`}
                autoPlay
                muted
                loop
                playsInline // مهم لأجهزة iPhone
                disablePictureInPicture // منع خاصية "صورة داخل صورة"
                controls={false} // إخفاء أزرار التحكم
                style={{ display: "block", width: "100%" }}
              />
            </div>
          )}
          <div
            style={{
              position: "absolute",
              top: item.top,
              left: item.left,
              transform: "translate(-50%, -50%)",
              textAlign: item.textAlign,
              width: item.width,
              color: item.color || "#000", // استخدام لون النص المحدد
            }}
          >
            <AnimatedDetailsText
              text={{
                title: item.title,
                subtitle: item.subtitle,
              }}
              textAlign={item.textAlign}
              margin="20px 0"
              padding="10px"
              direction={item.direction}
              zoom={item.zoom}
              fontSize="20px"
              color={item.color} // تمرير اللون إلى `AnimatedDetailsText`
            />
          </div>
          {index === 0 && (
            <div style={{ textAlign: "center" }}>
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  marginTop: "40px",
                }}
              >
                Product Models
              </h1>
              <div>
                <ModelSlider models={modelsData} />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default VeneraDimmer;

